export enum NotificationType {
	Questionnaire = "questionnaire",
}
